import React, { useContext, useState, useEffect } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import BusinessReports from '../../components/BusinessReports';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';
import { useHistory } from 'react-router-dom';

const BusinessReportsPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const [trigger, setTrigger] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (role !== "admin") {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>  
      { role === "admin" ? <AdminHeader trigger={trigger} /> : <LoginHeader trigger={trigger} /> }
      <main>
        <BusinessReports />
      </main>
      <LoginFooter />
    </>
  )
}

export default BusinessReportsPage;